const navigationRo = {
    "menu_editor": "Meniu",
    "settings": "Setări",
    "payment_settings": "Setări de plată",
    "user_management": "Gestionarea utilizatorilor",
    "logout": "Deconectare",
    "subscription": "Abonament",
    "new_restaurant": "Creați un restaurant nou",
    "privacy_policy": "Politica de confidențialitate",
    "terms_and_conditions": "Termeni și condiții",
    "statistics": "Statistici",
    "mozrest": "Manager de recenzii",
    "signup": "Înregistrare"
};

export default navigationRo;
